"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carobbio-degli-angeli": {
    "1071cf6d": [{
      "hkey": "ef04ce5b",
      "slug": "carobbio-degli-angeli",
      "name": "Carobbio degli Angeli",
      "primary": true,
      "skipSearch": false
    }],
    "cicola": [{
      "hkey": "ef04ce5b",
      "slug": "carobbio-degli-angeli",
      "name": "Carobbio degli Angeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3e7216d": [{
      "hkey": "ef04ce5b",
      "slug": "carobbio-degli-angeli",
      "name": "Carobbio degli Angeli",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano-degli-angeli": [{
      "hkey": "ef04ce5b",
      "slug": "carobbio-degli-angeli",
      "name": "Carobbio degli Angeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;